import { create } from 'zustand';

export const useCustomerAppointmentStore = create((set) => ({
  location: [],
  businessList: [],
  selectedLocation: null, //for leicester
  appointmentTypes: [
    // {
    //   type: 'Emergency Dental Consultation | Adult',
    //   time: '30min',
    //   cost: '£60'
    // },
    // {
    //   type: 'Emergency Dental Consultation | Child',
    //   time: '30min',
    //   cost: '£60'
    // }
  ],
  selectedAppointment: 0,
  refundModal: false,
  notificationList: [],
  notifications: [],
  businessName: null,
  businessLogo: null,
  appointmentModal: false,
  updateAppointmentModal: () =>
    set((state) => {
      return {
        ...state,
        appointmentModal: !state.appointmentModal
      };
    }),
  setAllBusiness: (businessList) =>
    set((state) => {
      return {
        ...state,
        businessList
      };
    }),
  setAllLocations: (location) =>
    set((state) => {
      return {
        ...state,
        location
      };
    }),
  setAllNotifications: (notifications) =>
    set((state) => {
      return {
        ...state,
        notifications
      };
    }),
  setAllAppointments: (appointmentTypes) =>
    set((state) => {
      return {
        ...state,
        appointmentTypes
      };
    }),
  setRefundModal: (refundModal) =>
    set((state) => {
      return {
        ...state,
        refundModal
      };
    }),
  changeSelectedLocation: (selectedLocation) =>
    set((state) => {
      return {
        ...state,
        selectedLocation
      };
    }),
  changeBusinessName: (businessName) =>
    set((state) => {
      return {
        ...state,
        businessName
      };
    }),
  changeBusinessLogo: (businessLogo) =>
    set((state) => {
      return {
        ...state,
        businessLogo
      };
    }),
  changeSelectedAppointmentType: (selectedAppointment) =>
    set((state) => {
      return {
        ...state,
        selectedAppointment
      };
    }),
  updateNotificationList: (newNotification) => {
    set((state) => {
      return {
        ...state,
        notificationList: [...state.notificationList, newNotification]
      };
    });
  },
  overRideNotificationList: (notificationList) => {
    set((state) => {
      return {
        ...state,
        notificationList
      };
    });
  }
}));
